import { render } from "./CurrentRequests.vue?vue&type=template&id=62dbca6c&scoped=true"
import script from "./CurrentRequests.vue?vue&type=script&lang=js"
export * from "./CurrentRequests.vue?vue&type=script&lang=js"

import "./CurrentRequests.vue?vue&type=style&index=0&id=62dbca6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62dbca6c"

export default script